import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
import FilterResponse from '../../_helpers/FilterResponse'
import toastr from 'toastr'

export const whService = {
    createnewOwner,
    addStepThreedata,
    addStepOnedata,
    getRequestdata,
    getWarehouseDetails,
    addChambers,
    removeChambers,
    compareWarehouses,
    getWarehouseListing,
    updateWareHouseStatus,
    addRemoveFavorite,
    updateCompareParameter,
    similarWarehouses,
    warehouseCamera,
    warehouseCameraDetails,
    getMyWarehouse
}

/**
 * 
 * @Tapas
 * For add owner during registration
 */
async function createnewOwner(data) {

    try {
        const response = await RestMethod.POST('/add-warehouse-owner', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function addStepOnedata(data) {

    try {
        const response = await RestMethod.POST('/add-warehouse', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function addStepThreedata(data) {

    try {
        const response = await RestMethod.POST('/warehouse-details', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function addChambers(data) {
    try {
        const response = await RestMethod.POST('/add-warehouse-chamber', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getRequestdata(id) {

    try {
        let url = 'warehouse-request-details/' + id
        const response = await RestMethod.GET(url);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getWarehouseDetails(id) {

    try {
        let url = 'warehouse/' + id
        const response = await RestMethod.GET(url);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function removeChambers(id) {

    try {
        let url = 'delete-warehouse-chamber/' + id
        const response = await RestMethod.PUT(url);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        //toastr.info('Request send  Successfull')
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function compareWarehouses(warehouseIds) {

    try {
        const response = await RestMethod.POST('/compare-warehouse', warehouseIds);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function getWarehouseListing(offset, limit, queryString) {
    var reuestlink = "/all-warehouse?";
    if (queryString) {
        reuestlink = reuestlink + queryString
    }
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }

    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateWareHouseStatus(data) {
    try {
        let url = 'update-warehouse-status/' + data.id
        const response = await RestMethod.PUT(url, data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function addRemoveFavorite(id) {
    try {
        let url = 'add-favorite/' + id
        const response = await RestMethod.PUT(url);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function updateCompareParameter(compareParameters) {

    try {
        const response = await RestMethod.POST('/comparison-parameters', compareParameters);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function similarWarehouses(data) {

    try {
        const response = await RestMethod.POST('/similar-warehouse', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function warehouseCamera(data, id) {
    try {
        const response = await RestMethod.PUT('/warehouse-camera/' + id, data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function warehouseCameraDetails(id) {
    try {
        const response = await RestMethod.GET('/warehouse-camera-details/' + id);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function getMyWarehouse() {
    try {
        const response = await RestMethod.GET('/warehouse-owner-dashboard');
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}